import { FC } from 'react';

import { Alert, Snackbar, styled } from '@mui/material';

import { Z_INDEX } from '@/constants/zIndex';
import { useToastStore } from '@/store';

const Root = styled(Snackbar)(() => ({}));

export const Toast: FC = () => {
  const {
    open,
    type,
    message,
    vertical,
    horizontal,
    onClose,
    updateToast,
    autoHideDuration,
  } = useToastStore();

  function handleClose(_event: React.SyntheticEvent | Event, reason?: string) {
    // Ignore clickaway to prevent interference with other click handlers
    // Toast should only close via X button or auto-hide timeout
    if (reason === 'clickaway') {
      return;
    }
    updateToast({ open: false, type });
    if (onClose) onClose();
  }

  return (
    <Root
      open={open}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{
        vertical,
        horizontal,
      }}
      sx={{ zIndex: Z_INDEX.TOAST_NOTIFICATION }}
    >
      <Alert
        onClose={handleClose}
        severity={type}
        sx={{ width: '100%' }}
        variant="filled"
      >
        {message}
      </Alert>
    </Root>
  );
};
